<!-- Отдельная смысловая группа действий ресурса в настройках роли. -->
<template>
  <PermissionRoleSettingsSection
    :title="section.title"
    :description="section.description"
    :help-text="section.help_text"
    :icon="section.icon"
  >
    <div class="permission-action-section__option-list">
      <PermissionRoleToggleButton
        v-for="permission in section.permissions"
        :key="permission.action"
        :label="permission.label"
        :selected="permission.value"
        :disabled="disabled"
        @click="$emit('toggle', permission.action)"
      />
    </div>
  </PermissionRoleSettingsSection>
</template>

<script>
import PermissionRoleSettingsSection from "@/components/PermissionRole/SettingsSection.vue";
import PermissionRoleToggleButton from "@/components/PermissionRole/ToggleButton.vue";

export default {
  name: "PermissionRoleActionSection",

  components: {
    PermissionRoleSettingsSection,
    PermissionRoleToggleButton,
  },

  props: {
    section: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },

  emits: ["toggle"],
};
</script>

<style scoped>
.permission-action-section__option-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 768px) {
  .permission-action-section__option-list {
    gap: 10px;
  }
}
</style>
